/**
 * jobDeliverables.js — The job's free-text deliverables field as a list of rows.
 *
 * Two writers share the field. The Quote Builder joins its line descriptions
 * with ", " (buildJobData in useQuoteBuilder), and the web-order intake writes
 * one line per row (formatOrderLines in server/lib/emailTemplates.js), whose
 * prices ("$1,028.00") and bullets carry commas of their own. Splitting web
 * orders on commas broke "$1,028.00" into "$1" and "028.00".
 *
 * So text with a line break, or a single web-order line ("- Photos   $449.00"),
 * splits on lines only; a one-line comma list from the Quote Builder or an
 * older hand-typed job still splits on commas.
 */
export function splitDeliverables(text) {
  const s = String(text ?? '');
  const byLine = s.includes('\n') || /^\s*- /.test(s);
  return s.split(byLine ? /\n+/ : /,/).map((d) => d.trim()).filter(Boolean);
}
